<template>
  <div class="passenger-editor">
    <a-form :form="form">
      <a-form-item
        label="姓名"
        required
        :label-col="{ span: labelWidth }"
        :wrapper-col="{ span: wrapWidth }"
      >
        <a-input
          :disabled="true"
          v-decorator="[
                'passengerName',
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'blur'
                }
              ]"
          :size="size"
        />
      </a-form-item>
      <a-form-item
        label="证件类型"
        required
        :label-col="{ span: labelWidth }"
        :wrapper-col="{ span: wrapWidth }"
      >
        <a-select
          v-decorator="[
                'idType',
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'change'
                }
              ]"
          :size="size"
        >
          <a-select-option value="NI">身份证</a-select-option>
          <a-select-option value="ID16">户口簿</a-select-option>
          <a-select-option value="PP">有效护照</a-select-option>
          <a-select-option value="JG">军官证</a-select-option>
          <a-select-option value="NID">外国人永久居留身份证</a-select-option>
          <a-select-option value="HM">港澳台居民居住证</a-select-option>
          <a-select-option value="ID">其他</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        label="证件号码"
        required
        :label-col="{ span: labelWidth }"
        :wrapper-col="{ span: wrapWidth }"
      >
        <a-input
          v-decorator="[
            'certificateNo',
            {
              rules: [
                {
                  validator: handleFieldValidate
                }
              ],
              validateTrigger: 'blur'
            }
          ]"
          :size="size"
        />
      </a-form-item>
      <a-form-item label="验证码" :label-col="{ span: labelWidth }" :wrapper-col="{ span: 14 }">
        <l8-imgcaptcha v-model="captcha" :size="'large'" ref="imgcaptcha"></l8-imgcaptcha>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 10 }">
        <a-button type="primary" html-type="submit" size="large" :loading="editing" @click="handleSubmit">提 交</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import Vue from 'vue'
import { find } from 'lodash'
import { updatePassenger } from '@/apis/order'
import { validate } from '@/assets/js/validate'
import ImgCaptcha from '@/components/imgcaptcha'
import { isYoungOrOld } from '@/assets/js/util'
import { idTypeMap } from '@/dicts/order'
import yoProductConfig from '@/data/yoProductConfig'

Vue.use(ImgCaptcha)
const mainSettings = window.__MICRO_ROOT__ ?? {}

export default {
  props: {
    initData: { type: Object },
    allSegs: { type: Object },
    size: {
      type: String,
      default: 'large'
    }
  },
  data () {
    return {
      idTypeMap,
      form: this.$form.createForm(this),
      captcha: '',
      labelWidth: 6,
      wrapWidth: 16,
      editing: false
    }
  },
  watch: {
    initData: {
      handler: function (val, oldVal) {
        if (val) {
          this.updateForm(val)
        }
      },
      deep: true,
      immediate: true
    }
  },
  created () {

  },
  mounted () {
    if (this.initData.id) {
      this.updateForm(this.initData)
    }
  },
  methods: {
    updateForm (passenger) {
      if (passenger.id) {
        let idType = passenger.certificateType

        setTimeout(() => {
          this.form.setFieldsValue({
            passengerName: passenger.passengerName,
            idType: idType,
            certificateNo: passenger.certificateNo
          })
        }, 10)
      } else {
        setTimeout(() => {
          this.form.setFieldsValue({
            passengerName: '',
            idType: '',
            certificateNo: ''
          })
        }, 0)
      }
    },
    handleFieldValidate (rule, value, callback) {
      let formValues = this.form.getFieldsValue()

      validate('usualPassenger', formValues, rule.fullField).then(({ valid, errors }) => {
        if (valid) {
          callback && callback()
        } else {
          callback(errors[0].message)
        }
      })
    },
    async handleSubmit (e) {
      e.preventDefault()

      this.form.validateFields(async (err, values) => {
        if (!err) {
          // 校验青老年产品的对乘机人证件和年龄的判断
          const { flightSegments, passengerType } = this.initData
          const yoProduct = find(yoProductConfig, { airline: mainSettings.airline })
          if (yoProduct) {
            const { youngMin, youngMax, oldMin } = yoProduct
            const isQLNTH = Boolean(flightSegments.find(seg => { return seg.productCode === yoProduct.productCode }))
            if (isQLNTH) {
              if (passengerType === '成人') {
                if (values.idType !== 'NI') {
                  this.$message.error('旅客您好，预订青老年特惠产品，成人旅客须使用身份证。')
                  return
                }
                if (!isYoungOrOld(values.certificateNo, flightSegments[0].departureDate, { youngMin, youngMax, oldMin })) {
                  this.$message.error(`旅客您好，预订青老年特惠产品，成人旅客年龄须为${youngMin}周岁(含)至${youngMax}周岁(含)或${oldMin}周岁(含)以上。`)
                  return
                }
              }
            }
          }
          if (!this.captcha) {
            this.$message.error('请填写正确的图片验证码')
            return
          }
          let params = {}

          params.certificateNo = values.certificateNo
          params.certificateType = values.idType
          params.passengerName = values.passengerName
          params.passengerType = passengerType
          params.pnrValue = this.initData.pnrValue
          params.captcha = this.captcha
          params.id = this.initData.id

          this.editing = true

          updatePassenger(params).then((res) => {
            this.editing = false

            if (res.errors && !res.valid) {
              this.$message.error(res.errors[0].message)
            } else {
              this.$message.success('修改乘机人成功！')
              this.$emit('change', params)
            }
          }).catch((e) => {
            this.$refs.imgcaptcha.refresh()
            this.editing = false

            this.$message.error(e.message)
          })
        }
      })
    }
  }
}
</script>

<style lang="less">

</style>
